import { Typography } from "@material-ui/core";
import * as React from "react";

export const CashflowRoundingNote: React.FC = () => (
  <Typography variant="caption" color="textSecondary" display="block">
    日割り計算・四捨五入により、表示金額の差と収支が1円異なる場合があります。
  </Typography>
);
